import { createAction, props } from '@ngrx/store';

import { DuttiDateFormat } from '@frontend/common/duttidate';

export const ActionTypes = {
    SET_DEBUGBAR_STATUS: '[DebugBar] SET_DEBUGBAR_STATUS',
    SET_DEBUGBAR_STATUS_SUCCESS: '[DebugBar] SET_DEBUGBAR_STATUS_SUCCESS',

    LOAD_DEBUGBAR_COMPONENT: '[DebugBar] LOAD_DEBUGBAR_COMPONENT',
    LOAD_DEBUGBAR_COMPONENT_SUCCESS: '[DebugBar] LOAD_DEBUGBAR_COMPONENT_SUCCESS',

    OPEN_CLOSE_DEBUGBAR: '[DebugBar] OPEN_CLOSE_DEBUGBAR',

    DESTROY_DEBUGBAR: '[DebugBar] DESTROY_DEBUGBAR',

    DEBUGBAR_CHANGE_RTL: '[DebugBar] DEBUGBAR_CHANGE_RTL',
    DEBUGBAR_CHANGE_RTL_SUCCESS: '[DebugBar] DEBUGBAR_CHANGE_RTL_SUCCESS',

    DEBUGBAR_CHANGE_SHOW_TRANSLATIONS: '[DebugBar] DEBUGBAR_CHANGE_SHOW_TRANSLATIONS',
    DEBUGBAR_CHANGE_SHOW_TRANSLATIONS_SUCCESS: '[DebugBar] DEBUGBAR_CHANGE_SHOW_TRANSLATIONS_SUCCESS',

    DEBUGBAR_CHANGE_USER_TYPE: '[DebugBar] DEBUGBAR_CHANGE_USER_TYPE',
    DEBUGBAR_CHANGE_USER_TYPE_SUCCESS: '[DebugBar] DEBUGBAR_CHANGE_USER_TYPE_SUCCESS',

    DEBUGBAR_CHANGE_FONT_HELPER_STATUS: '[DebugBar] DEBUGBAR_CHANGE_FONT_HELPER_STATUS',
    DEBUGBAR_CHANGE_FONT_HELPER_STATUS_SUCCESS: '[DebugBar] DEBUGBAR_CHANGE_FONT_HELPER_STATUS_SUCCESS',

    // eslint-disable-next-line no-secrets/no-secrets
    DEBUGBAR_CHANGE_SHOW_PRODUCTS_INFO: '[DebugBar] DEBUGBAR_CHANGE_SHOW_PRODUCTS_INFO',
    DEBUGBAR_CHANGE_SHOW_PRODUCTS_INFO_SUCCESS: '[DebugBar] DEBUGBAR_CHANGE_SHOW_PRODUCTS_INFO_SUCCESS',

    DEBUGBAR_CHANGE_SHOW_CATEGORY_IDS: '[DebugBar] DEBUGBAR_CHANGE_SHOW_CATEGORY_IDS',
    DEBUGBAR_CHANGE_SHOW_CATEGORY_IDS_SUCCESS: '[DebugBar] DEBUGBAR_CHANGE_SHOW_CATEGORY_IDS_SUCCESS',

    // eslint-disable-next-line no-secrets/no-secrets
    DEBUGBAR_CHANGE_SHOW_TIME_TRAVELLER: '[DebugBar] DEBUGBAR_CHANGE_SHOW_TIME_TRAVELLER',
    DEBUGBAR_CHANGE_SHOW_TIME_TRAVELLER_SUCCESS: '[DebugBar] DEBUGBAR_CHANGE_SHOW_TIME_TRAVELLER_SUCCESS',

    DEBUGBAR_CHANGE_TIME_TRAVELLER_DATA: '[DebugBar] DEBUGBAR_CHANGE_TIME_TRAVELLER_DATA',
    DEBUGBAR_CHANGE_TIME_TRAVELLER_DATA_SUCCESS: '[DebugBar] DEBUGBAR_CHANGE_TIME_TRAVELLER_DATA_SUCCESS',

    // eslint-disable-next-line no-secrets/no-secrets
    DEBUGBAR_CHANGE_SHOW_CMS_TOOLTIPS: '[DebugBar] DEBUGBAR_CHANGE_SHOW_CMS_TOOLTIPS',
    DEBUGBAR_CHANGE_SHOW_CMS_TOOLTIPS_SUCCESS: '[DebugBar] DEBUGBAR_CHANGE_SHOW_CMS_TOOLTIPS_SUCCESS',

    DEBUGBAR_CHANGE_PERIOD: '[DebugBar] DEBUGBAR_CHANGE_PERIOD',
    DEBUGBAR_CHANGE_PERIOD_SUCCESS: '[DebugBar] DEBUGBAR_CHANGE_PERIOD_SUCCESS',

    // eslint-disable-next-line no-secrets/no-secrets
    DEBUGBAR_TOGGLE_SHOW_SUMMARY_SHOPCART: '[DebugBar] DEBUGBAR_TOGGLE_SHOW_SUMMARY_SHOPCART',
};

export const SetDebugBarStatus = createAction(ActionTypes.SET_DEBUGBAR_STATUS);
export const SetDebugBarStatusSuccess = createAction(
    ActionTypes.SET_DEBUGBAR_STATUS_SUCCESS,
    props<{ debugBarStatus: any }>()
);

export const LoadDebugBarComponent = createAction(ActionTypes.LOAD_DEBUGBAR_COMPONENT);
export const LoadDebugBarComponentSuccess = createAction(
    ActionTypes.LOAD_DEBUGBAR_COMPONENT_SUCCESS,
    props<{ isComponentInjected: boolean }>()
);

export const OpenCloseDebugBar = createAction(ActionTypes.OPEN_CLOSE_DEBUGBAR, props<{ isOpen: boolean }>());

export const DestroyDebugBar = createAction(ActionTypes.DESTROY_DEBUGBAR);

export const DebugBarChangeRtl = createAction(ActionTypes.DEBUGBAR_CHANGE_RTL, props<{ isRtl: boolean }>());
export const DebugBarChangeRtlSuccess = createAction(
    ActionTypes.DEBUGBAR_CHANGE_RTL_SUCCESS,
    props<{ isRtl: boolean }>()
);

export const DebugBarChangeShowTranslations = createAction(
    ActionTypes.DEBUGBAR_CHANGE_SHOW_TRANSLATIONS,
    props<{ showTranslations: boolean }>()
);
export const DebugBarChangeShowTranslationsSuccess = createAction(
    ActionTypes.DEBUGBAR_CHANGE_SHOW_TRANSLATIONS_SUCCESS,
    props<{ showTranslations: boolean }>()
);

export const DebugBarChangeUserType = createAction(
    ActionTypes.DEBUGBAR_CHANGE_USER_TYPE,
    props<{ userIsVip: boolean }>()
);
export const DebugBarChangeUserTypeSuccess = createAction(
    ActionTypes.DEBUGBAR_CHANGE_USER_TYPE_SUCCESS,
    props<{ userIsVip: boolean }>()
);

export const DebugBarChangeFontHelper = createAction(
    ActionTypes.DEBUGBAR_CHANGE_FONT_HELPER_STATUS,
    props<{ fontHelperEnabled: boolean }>()
);

export const DebugBarChangeFontHelperSuccess = createAction(
    ActionTypes.DEBUGBAR_CHANGE_FONT_HELPER_STATUS_SUCCESS,
    props<{ fontHelperEnabled: boolean }>()
);

export const DebugBarChangeShowProductsInfo = createAction(
    ActionTypes.DEBUGBAR_CHANGE_SHOW_PRODUCTS_INFO,
    props<{ showProductsInfo: boolean }>()
);
export const DebugBarChangeShowProductsInfoSuccess = createAction(
    ActionTypes.DEBUGBAR_CHANGE_SHOW_PRODUCTS_INFO_SUCCESS,
    props<{ showProductsInfo: boolean }>()
);

export const DebugBarChangeShowCategoryIds = createAction(
    ActionTypes.DEBUGBAR_CHANGE_SHOW_CATEGORY_IDS,
    props<{ showCategoryIds: boolean }>()
);
export const DebugBarChangeShowCategoryIdsSuccess = createAction(
    ActionTypes.DEBUGBAR_CHANGE_SHOW_CATEGORY_IDS_SUCCESS,
    props<{ showCategoryIds: boolean }>()
);

export const DebugBarChangeShowTimeTraveller = createAction(
    ActionTypes.DEBUGBAR_CHANGE_SHOW_TIME_TRAVELLER,
    props<{ showTimeTraveller: boolean }>()
);

export const DebugBarChangeShowTimeTravellerSuccess = createAction(
    ActionTypes.DEBUGBAR_CHANGE_SHOW_TIME_TRAVELLER_SUCCESS,
    props<{ showTimeTraveller: boolean }>()
);

export const DebugBarChangeTimeTravellerData = createAction(
    ActionTypes.DEBUGBAR_CHANGE_TIME_TRAVELLER_DATA,
    props<{ date: DuttiDateFormat.ISO_NO_UTC }>()
);

export const DebugBarChangeTimeTravellerDataSuccess = createAction(
    ActionTypes.DEBUGBAR_CHANGE_TIME_TRAVELLER_DATA_SUCCESS,
);

export const DebugBarChangeShowCmsTooltips = createAction(
    ActionTypes.DEBUGBAR_CHANGE_SHOW_CMS_TOOLTIPS,
    props<{ showCmsTooltips: boolean }>()
);

export const DebugBarChangeShowCmsTooltipsSuccess = createAction(
    ActionTypes.DEBUGBAR_CHANGE_SHOW_CMS_TOOLTIPS_SUCCESS,
    props<{ showCmsTooltips: boolean }>()
);

export const DebugBarChangePeriod = createAction(
    ActionTypes.DEBUGBAR_CHANGE_PERIOD,
    props<{ period: string }>()
);

export const DebugBarChangePeriodSuccess = createAction(
    ActionTypes.DEBUGBAR_CHANGE_PERIOD_SUCCESS,
    props<{ period: string }>()
);

export const DebugBarToggleShowSummaryShopCart = createAction(
    ActionTypes.DEBUGBAR_TOGGLE_SHOW_SUMMARY_SHOPCART
);
